import { render, staticRenderFns } from "./GroupsMyBookings.vue?vue&type=template&id=82e5f190&scoped=true&"
import script from "./GroupsMyBookings.vue?vue&type=script&lang=ts&"
export * from "./GroupsMyBookings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e5f190",
  null
  
)

export default component.exports